import {ChangeDetectorRef, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { StateService } from '../../../../services/state.service';

import { AppService } from '../../../../services/app.service';
import { UtilitaryService } from '../../../../services/utilitary.service';
import { MatDrawer, MatPaginator, MatSidenav, MatTableDataSource, Sort } from '@angular/material';
import { of, Subject } from 'rxjs';
import { DroitsService } from '../../../../services/droits.service';
import { CourrierService } from '../../../../services/courrier.service';
import { JSONRpcResponse } from '../../../../Interfaces/JSONRpcResponse';
import { isArray } from 'lodash';
declare var $: any;

@Component({
    selector: 'courrier-dialog',
    templateUrl: 'courrier-dialog.component.html',
    styleUrls: ['./courrier-dialog.component.scss']
})


export class CourrierDialog implements OnInit {
    
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild('drawer', {static: true}) drawer: MatDrawer;

    droits: any = [];
    config: any = {
        height: '64vh',
        lang: "fr-FR",
        dialogsInBody: true,
        toolbar: [
          ['slider', ['testBtn']],
          ['courrier', ['courrierPrevious','courrierNext']],
          ['style', ['bold', 'italic', 'underline','clear']],
          ['para', ['ul', 'ol', 'paragraph', 'height']],
          ['insert', ['table','pagebreak']],
          ['upload', ['picture','link']],
          ['download', ['pdf']],
         
          
        ],
        buttons: {
			'courrierPrevious':this.customButtonHtmlPrevious.bind(this),
            'courrierNext':this.customButtonHtmlNext.bind(this),
            'testBtn': this.customButton.bind(this),
            'pdf': this.customButtonPdf.bind(this),
            'pagebreak': this.customButtonPageBreak.bind(this)
          }
      };
    objectKeys = Object.keys;
    courriers: any[];
    formats: any[];
    typeCourrier: any[];
    autreCourriers: any[];
    result: any = {
		selectedCourrier: {},
		selectedCourrierDossier: [],
		selectedDestinataire: [],
		selectIndex: 0,
		selectedFormat: "",
    };
    courrierType: any[] = [];
    courrierAutre: any[] = [];

    firstChamp:any = '';
    secondChamp:any = '';
    thirdChamp:any = '';

    destinataire:any;
    cachedDemande:any;

    isEditable: boolean = true;
    signature: boolean = false;
	dataSource=new MatTableDataSource();

	columns: any[]=[];
    displayedColumns = [];

	length :number = 0;
	pageSize :number = 10;
	currentPage :number = 0;
	page :number = 0;

	expanded : any[] = [];

	totalLength:number = 0;
	loading :boolean=false;
	expandedElement: any;
    
    filters: any;
    sort: any;

    loadingCour: boolean = false;
    dossierInit: any;

	formatExport:string= "HTML2PDF";

	nativeMultiple:boolean=false;
	selectedRelation: any = {};

	_optionsCourrier: any
	_optionsCourrierDossiers: any[]=[];

    instructionCourrierId: any
	instruction: any

    mainDestinataire: any
    validButtonActive: boolean = true
    validDestinataireValid: boolean = true

    exportOptions: any[] = ["pdf","docx"];

	isCourrrierExist:boolean=false;
	
    constructor(
        public dialogRef: MatDialogRef<CourrierDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private appService: AppService,
        private courrierService: CourrierService,
        private utilities: UtilitaryService,
        public stateService: StateService,
        private changeDetectorRef : ChangeDetectorRef,
        public droitsService: DroitsService
    ) {}

    ngOnInit() {
        console.log("CourrierDialog",this.data);
        this.droits = this.data.droits;
        this.isEditable = this.data.isEditable;
        this.signature = this.data.signature;
        this.firstChamp = this.data.courrier && this.data.courrier.libres.length && this.data.courrier.libres[0].value ? this.data.courrier.libres[0].value : '';
        this.secondChamp = this.data.courrier && this.data.courrier.libres.length && this.data.courrier.libres[1].value ? this.data.courrier.libres[1].value : '';
        this.thirdChamp = this.data.courrier && this.data.courrier.libres.length && this.data.courrier.libres[2].value ? this.data.courrier.libres[2].value : '';
        this.result.libres = [
            {
                "key":"CHAMP_LIBRE0",
                "value":this.firstChamp
            },
            {
                "key":"CHAMP_LIBRE1",
                "value":this.secondChamp
            },
            {
                "key":"CHAMP_LIBRE2",
                "value":this.thirdChamp
            }
        ]

        
		this.drawer.openedChange.subscribe((o: boolean) => { 
            console.log("_drawerToggle IsOpen: ",o)
			 
            this.validButtonActive = !o
            this.changeDetectorRef.detectChanges()

            if (!o) {
               console.log("_drawerToggle refresh",this._optionsCourrierDossiers);
                  this.initCourrier();
               } 

         });

        this.appService.getListCourrier(this.data.demande).subscribe((result) => {
            this.courriers = result.result;
            this.utilities.log(this.courrierType, this.courrierAutre);
        });
        this.appService.getParamsDemandeCourrier(this.data.demande.type.ID).subscribe((result) => {
            this.typeCourrier = result.result;
           /* result.result.forEach((cour) => {
                if(cour.types[this.data.demande.type.ID])
                    this.typeCourrier.push(cour);
            });
            */
            this.typeCourrier.forEach((type) => {
                if(this.data.courrier && this.data.courrier.courrier.key === type.key){
                    this.result.selectedCourrier = type;
                    this.setexportOptions(this.result.selectedCourrier)
                    if(this.data.courrier && this.data.courrier.destination)
                        this.destinataire = this.data.courrier.destination.dossierID;
                    this.getHtmlCourrier(this.result.selectedCourrier, true, this.destinataire);
                }
            });
        });
        if(this.signature && this.data.courrier){
            this.isEditable = false;
        }
        
        this.stateService.dossier.subscribe((dossier) => {
            this.filters = {
                dossier : {
                    value : dossier.ID
                }
            }
            if(this.data.courrier && this.data.courrier.destination) {
                this.destinataire = this.data.courrier.destination.dossierID;
                // this._optionsCourrier.destination = this.data.courrier.destination.ID
            } else {
                this.destinataire = dossier.ID;
            }
            this.dossierInit = dossier;
        })

        this.result.selectedDestinataire = []

        this.instructionCourrierId = 0
        // this.instructionCourrierId = this.data.courrier.ID
        // this.instructionCourrierId = this.data.demande.ID ? this.data.demande.ID : 0
        // this.instructionCourrierId = this.result.selectedCourrier.ID || 0

        if (this.data && this.data.instruction && this.data.instruction !== null) {
            this.instruction = this.data.instruction
        }

        let ops:any={
            ID: this.data.courrier.ID,
            courrier: this.data.courrier.courrier.key,
            alldossier: true,
            // intervention: this.intervention,
            dossier: (this.instruction != undefined && this.instruction) ? this.instruction.ID: null,
            destination: this.destinataire,
            instruction: (this.instruction != undefined && this.instruction) ? this.instruction.ID: null,
            validation: true
        };

		if (this.selectedRelation[this.destinataire+""]==undefined) {
            this.selectedRelation[this.destinataire+""]=false;
        }
            
        this.selectedRelation[this.destinataire+""]=true;
        this.mainDestinataire = this.destinataire
            
        this._optionsCourrierDossiers.push(ops);
        console.log("ngOnInit nort Mulit",ops);
        this.result.selectedDestinataire.push(this.instruction);

        console.log("OPTIONS", ops, this.data)
    }

	initCourrier() {
        //Multi courrier panier
		console.log("___this._optionsCourrierDossiers",this._optionsCourrierDossiers,this.instructionCourrierId)
		this.loadingCour=true;

        if (!this.validDestinataireValid) return this.dialogRef.close(true)

		if (this._optionsCourrierDossiers.length>0){
            this.courrierService.htmlMulti(this.instructionCourrierId, this._optionsCourrierDossiers).subscribe((response: JSONRpcResponse) => {
                this.loadingCour=false;
                if (response && response.result && response.result[0]) {
                    this.result.selectedCourrier = response.result[0];
					this.result.selectedCourrierDossier = response.result;
					console.log('initCourrier',this.result.selectedCourrierDossier, this.result);
					this.getDataPage();
				}
			})
            /*
		   for(let i=0;i<this._optionsCourrierDossiers.length;i++) {
			this.courrierService.html(this.demandeCourrierId, this._optionsCourrierDossiers[i]).subscribe((response: JSONRpcResponse) => {
				if (response && response.result) {
					if(i==0){
                        this.result.selectedCourrier = response.result;
                    }
					this.result.selectedCourrierDossier.push(response.result)
					console.log('initCourrier',this._optionsCourrierDossiers[i], this.result);
				}
			})
		   }*/
        }
        else{
            this.courrierService.html(this.instructionCourrierId, this._optionsCourrier).subscribe((response: JSONRpcResponse) => {
                if (response && response.result) {
                    this.result.selectedCourrier = response.result
                }
                this.loadingCour=false;
                this.getDataPage();
            })
        }
		
	}

    configureFormats(listFormat: any[]) {
        this.formats = listFormat;
        if(listFormat["PDF"])
            this.result.selectedFormat = listFormat["PDF"];
    }

    getHtmlCourrier(demandecourrier: any, init:boolean = false, destinataire?:any, resetHTML?: boolean) {
        this.formats = demandecourrier.format;
        this.cachedDemande = demandecourrier;
        if(this.data.courrier)
            demandecourrier.ID = this.data.courrier.ID;
        else
            demandecourrier.ID = '0';
        this.result.libres = [
            {
                "key":"CHAMP_LIBRE0",
                "value":this.firstChamp
            },
            {
                "key":"CHAMP_LIBRE1",
                "value":this.secondChamp
            },
            {
                "key":"CHAMP_LIBRE2",
                "value":this.thirdChamp
            }
        ]
        if(!destinataire)
            this.destinataire = this.dossierInit.ID;
        else
            this.destinataire = destinataire;
        this.appService.getHtmlCourrier(demandecourrier, this.data.demande, this.result.libres, this.destinataire).subscribe((res) => {
            this.result.selectedCourrier.html = res.result.html;
            if(this.data.courrier && this.data.courrier.html && !resetHTML)
                this.result.selectedCourrier.html = this.data.courrier.html;

			this.isCourrrierExist=(res.result!=undefined && res.result.value!=undefined && res.result.value.ID!=undefined);
			console.log("getHtmlCourrier",res.result,this.isCourrrierExist);
            this.result.libres = [
                {
                    "key":"CHAMP_LIBRE0",
                    "value":this.firstChamp
                },
                {
                    "key":"CHAMP_LIBRE1",
                    "value":this.secondChamp
                },
                {
                    "key":"CHAMP_LIBRE2",
                    "value":this.thirdChamp
                }
            ]
            if(init)
                this.getDataPage();
            this.changeDetectorRef.detectChanges();
        });
    }
    save(close ?: boolean) {
        if (!this.validButtonActive || !this.validDestinataireValid) return

        this.result.destinataire = this.destinataire;
        this.result.libres = [
            {
                "key":"CHAMP_LIBRE0",
                "value":this.firstChamp
            },
            {
                "key":"CHAMP_LIBRE1",
                "value":this.secondChamp
            },
            {
                "key":"CHAMP_LIBRE2",
                "value":this.thirdChamp
            }
        ]
        this.loadingCour = true;
        console.log("save courrier",this.formatExport);

        if (this._optionsCourrierDossiers.length == 0) {
            this.appService.getCourrier(this.result.selectedCourrier, this.data.instruction.demande, this.formatExport, (this.data.courrier && this.data.courrier.ID ? this.data.courrier.ID : ''), this.result.libres, this.result.destinataire).then((courrier) => {         
                this.loadingCour = false;
                if(courrier.result.length > 0){
                    courrier.result.forEach((cour) => {
                        if(cour.ID === this.result.selectedCourrier.ID){
                            if(cour.value){
                                if(close)
                                    this.dialogRef.close(true);
                                else
                                    window.open(cour.value.url, '_blank');
                            }
                            else
                                of(window.confirm("Le type de courrier demandé n'est pas présent, problème de configuration"));
                        }
                    });
                }
            });
        } else {
            console.log("___COURRIERDOSSIER",this.result.selectedCourrierDossier,this.result.selectedCourrier);
			let _opt:any[]=[];
			//Actualiser la page actuelle
			this.result.selectedCourrierDossier[this.result.selectIndex]=this.result.selectedCourrier;
			//this._optionsCourrierDossiers[this.result.selectIndex].html = this.result.selectedCourrier.html
			for (let i=0;i<this._optionsCourrierDossiers.length;i++) {
                if (!this._optionsCourrierDossiers[i].ID) this._optionsCourrierDossiers[i].ID = 0
				this._optionsCourrierDossiers[i].html = this.result.selectedCourrierDossier[i].html;
				this._optionsCourrierDossiers[i].format=this.formatExport;
			}
			console.log("saveCourrier multiple",close,this._optionsCourrierDossiers);
				this.courrierService.gets(this._optionsCourrierDossiers).subscribe((response: JSONRpcResponse) => {
					this.loadingCour = false;
					if(close)
                          this.dialogRef.close(response.result)
                       else  {
					
						// this._snackBar.open('le(s) courrier est enregistré(s)', "ok", {
						// 	duration: 2000
						// })
						if (response.result!=undefined && response.result
		                && response.result.zipFile!=undefined 
		                && response.result.zipFile.url!=undefined 
		                && response.result.zipFile.url
		                ) {
							window.open(response.result.zipFile.url,' _blank');
						}
						if (response.result!=undefined && response.result
								&& response.result.options!=undefined)
								this._optionsCourrierDossiers=response.result.options;
						
						 this.changeDetectorRef.detectChanges();
						
					}
                })
        }
    }

    getDataPage(page:number=0,init:boolean=false,_nodata:boolean=false) {
        
        let _options={
          page:page,
          filters:this.filters,
          sorts: [this.sort]
          };
       this.loading=true;
        this.appService.getList("RELATION",_options,_nodata)
              .subscribe(list => {
            this.loading = false;

            this.columns=list.result.columns;
            this.columns.unshift({
                id: 'checkbox',
                label:""
            });

            this.displayedColumns = this.columns.map(x => x.id);
            if (list.result.datas.meta) {
                this.length=list.result.datas.meta.total;
                this.pageSize=list.result.datas.meta.perpage;
                this.currentPage=list.result.datas.meta.page;
              }
      
		    this.dataSource.data=list.result.datas.datas;

		    for(let i=0;i<this.dataSource.data.length;i++) {
				if (this.selectedRelation[this.dataSource.data[i]["id"]+""]==undefined) {
                    this.selectedRelation[this.dataSource.data[i]["id"]+""]=false;
                }
			}

            this.utilities.log('l',this.length);	
            this.utilities.log("get:liste",this.currentPage,this.length,this.columns,this.data);
            
            this.changeDetectorRef.detectChanges();
            if(this.paginator){
                this.paginator._intl.itemsPerPageLabel = "Nombre par page:";
                this.paginator._intl.getRangeLabel = (page, pageSize, length) => { 
                    if (length == 0 || pageSize == 0) {
                         return `0 de ${length}`; 
                    } 
                    length = Math.max(length, 0); 
                    const startIndex = page * pageSize; 
                    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize; 
                    return `${startIndex + 1} – ${endIndex} de ${length}`; 
                };
            }
          });
        }
	sortData(sort: Sort) {
		console.log(sort);
		this.loading = true;
	}
	onRowClicked(row) {
		this.utilities.log('Row clicked: ', row);
        if(this.isEditable)
		    this.expandedElement = this.expandedElement === row ? null : row;
    }

    public handlePage(e: any) {
		//this.currentPage = e.pageIndex;
		//this.pageSize = e.pageSize;
	//	this.dataSource.data=[];
		this.totalLength=0;
		let pagination:any={
			currentPage:e.pageIndex,
			pageSize:  e.pageSize
		};
		this.loading = true;
    }
    
    setDestinataire(event, row) {
        this.destinataire=row;
        let dest:any=row;
        let destID = dest.id

        console.log('Elent clicked: ', { event, row, selectedRelation: this.selectedRelation, destID: destID, rowID: row.id, destinataire: this.destinataire })
        //,this.selectedRelation[dest.dossierID];
        if (this.selectedRelation[destID]!=undefined &&
        	this.selectedRelation[destID]
        )
	        {
	        let isexist:boolean=false;
	        for(let i:number=0;i<this._optionsCourrierDossiers.length;i++) {
				if (this._optionsCourrierDossiers[i].destination!=undefined
				&& this._optionsCourrierDossiers[i].destination==this.destinataire.id
				)
				isexist=true;
				
			}
	        if (!isexist) {
				let ops:any={
                    ID: 0,
					courrier: this.data.courrier.courrier.key,
					alldossier: true,
					// intervention: this.intervention,
					dossier: (this.instruction!=undefined && this.instruction ) ? this.instruction.ID: null,
                    // dossier: this.data.demande.ID,
					destination:destID,
	                instruction: (this.instruction!=undefined && this.instruction ) ? this.instruction.ID: null
				};
				
                if (this.mainDestinataire === destID) {
                    ops.ID = this.data.courrier.ID
                }

				this._optionsCourrierDossiers.push(ops);
				let noid:boolean=true;
				let firsto:any;
				for(let i:number=0;i<this._optionsCourrierDossiers.length;i++) {
					let oop:any=this._optionsCourrierDossiers[i];
					if (oop.ID!=undefined &&  oop.ID>0)
						noid=false;
					if (i==0)
						firsto=oop;
				}
				
				if (noid && firsto!=undefined 
					 && firsto.ID!=undefined &&  firsto.ID==0
				 && this._optionsCourrierDossiers.length>0
				  ) {
						console.log("CourrierDialog id",firsto,noid,this.data.courrier.ID,this._optionsCourrierDossiers)
						firsto.ID=this.data.courrier.ID;
						this._optionsCourrierDossiers[0]=firsto;
				}
				
				
				console.log("setDestinataire nort Mulit",ops);
				this.result.selectedDestinataire.push(this.instruction ? this.instruction : undefined);
			}
	        
			
		} else {
			 let index:number=-1;
	        for(let i:number=0;i<this._optionsCourrierDossiers.length;i++) {
				if (this._optionsCourrierDossiers[i].destination!=undefined
				&& this._optionsCourrierDossiers[i].destination==destID
				)
				index=i;
				
			}
			console.log("remove courrier before",index,this._optionsCourrierDossiers);
			if (index>=0) {
				this._optionsCourrierDossiers.splice(index, 1);
			}
			
			let noid:boolean=true;
			let firsto:any;
			for(let i:number=0;i<this._optionsCourrierDossiers.length;i++) {
				let oop:any=this._optionsCourrierDossiers[i];
				if (oop.ID!=undefined &&  oop.ID>0)
					noid=false;
				if (i==0)
					firsto=oop;
			}
			
			if (noid && firsto!=undefined 
				 && firsto.ID!=undefined &&  firsto.ID==0
			 && this._optionsCourrierDossiers.length>0
			  ) {
					console.log("CourrierDialog id suppress",firsto,noid,this.data.courrier.ID,this._optionsCourrierDossiers)
					firsto.ID=this.data.courrier.ID;
					this._optionsCourrierDossiers[0]=firsto;
			}
			
			console.log("remove courrier after",index,this._optionsCourrierDossiers);
        }

        if (this._optionsCourrierDossiers.length <= 0) {
            this.validDestinataireValid = false

            this.changeDetectorRef.detectChanges()
        } else {
            this.validDestinataireValid = true

            this.changeDetectorRef.detectChanges()
        }
    }

    getTitle() {
        let title = "Choix d'édition de courrier"
      
        if (this.data.courrier) {
          title += ' - ' + this.data.courrier.courrier.libelle;
        }
      
        if (this.result.selectedCourrierDossier.length > 1) {
          title += ' (' + (this.result.selectIndex + 1) + '/' + this.result.selectedCourrierDossier.length + ')';
        }
      
        return title;
    }

    
	customButtonHtmlNext(context) {
		const ui = $.summernote.ui;
        const button = ui.button({
        contents: '<i class="la la-angle-right"></i>',
        tooltip: 'Courrier suivant',
        container: '.note-editor',
        className: 'note-btn',
        click: () => {
	        console.log("customButtonHtmlNext",this.result.selectIndex,this.result.selectedCourrierDossier.length,
            this.result.selectedDestinataire,this.result.selectedCourrierDossier)
            if (this.result.selectIndex<this.result.selectedCourrierDossier.length
                && this.result.selectedDestinataire[this.result.selectIndex+1]
                && this.result.selectedCourrierDossier[this.result.selectIndex+1]) {

				this.result.selectedCourrierDossier[this.result.selectIndex]=this.result.selectedCourrier;
			
             	this.result.selectIndex++;
             	this.destinataire=this.result.selectedDestinataire[this.result.selectIndex];
             	this.result.selectedCourrier=this.result.selectedCourrierDossier[this.result.selectIndex];
                console.log("customButtonHtmlNext after",this.result.selectIndex,this.result.selectedCourrierDossier);
            
             }
            this.changeDetectorRef.detectChanges();
        }
        });
        return button.render();
		
    }
    
    customButtonHtmlPrevious(context) {
		const ui = $.summernote.ui;
        const button = ui.button({
        contents: '<i class="la la-angle-left"></i>',
        tooltip: 'Courrier précedent',
        container: '.note-editor',
        className: 'note-btn',
        click: () => {
	        console.log("customButtonHtmlPrevouis",this.result.selectIndex,this.result.selectedCourrierDossier.length)
            if (this.result.selectIndex>0) {
				this.result.selectedCourrierDossier[this.result.selectIndex]=this.result.selectedCourrier;
	
             	this.result.selectIndex--;
             	
             	this.destinataire=this.result.selectedDestinataire[this.result.selectIndex];
             	this.result.selectedCourrier=this.result.selectedCourrierDossier[this.result.selectIndex];
                console.log("customButtonHtmlNext after",this.result.selectIndex,
                this.result.selectedCourrierDossier,this.result.selectedCourrierDossier,
                this.destinataire)
            
             }
            this.changeDetectorRef.detectChanges();
        }
        });
        return button.render();	
    }

    customButton(context) {
      //  console.log($.summernote);
        const ui = $.summernote.ui;
        const button = ui.button({
        contents: ' <img id="expandDrawer" class="reverse" src="./assets/media/icons/svg/Navigation/Angle-double-left.svg" />',
        tooltip: 'Plus d\options',
        container: '.note-editor',
        className: 'note-btn',
        click: () => {
            this.drawer.toggle();
            this.changeDetectorRef.detectChanges();
        }
        });
        return button.render();
    }

    customButtonPdf(context) {
      //  console.log($.summernote);
        const ui = $.summernote.ui;
        const button = ui.button({
        contents: ' <i class="material-icons">picture_as_pdf</i>',
        tooltip: 'Télécharger le PDF',
        container: '.note-editor',
        className: 'note-btn',
        click: () => {
            console.log("Télécharger");
            this.save(false);
            this.changeDetectorRef.detectChanges();
        }
        });
        return button.render();
    }
    
    customButtonPageBreak(context) {
       // console.log($.summernote);
        const ui = $.summernote.ui;
        const button = ui.button({
        contents: '<i class="la la-copy"></i>',
        tooltip: 'Insert nouvelle page',
        container: '.note-editor',
        className: 'note-btn',
        click: () => {
            
             let html='<div style="page-break-after:always; clear:both"><i class="la la-copy" title="Nouvelle page"></i></div>';
             context.invoke('editor.restoreRange');
             context.invoke('editor.focus');
             context.invoke('editor.pasteHTML', html);
             
             console.log("to insrt html",html);
            this.changeDetectorRef.detectChanges();
        }
        });
        return button.render();
    }

    setexportOptions(courrier){
        if(courrier.param != undefined 
            && courrier.param 
            && courrier.param.format != undefined 
            && courrier.param.format && isArray(courrier.param.format) 
            && courrier.param.format.length>0
        ){
            this.exportOptions = courrier.param.format;
            if(this.exportOptions.length === 1){
                this.formatExport = this.exportOptions[0] === 'pdf' ? 'HTML2PDF' : 'HTML2DOCX';
            }
        }
        else{
            this.exportOptions = ["pdf","docx"];
        }
        console.log("setexportOptions",courrier,this.exportOptions)
    }
}

